// extracted by mini-css-extract-plugin
export default {"Maindiv":"EditLanguage_Maindiv__MRa07","container":"EditLanguage_container__EU7iE","saveBar":"EditLanguage_saveBar__uJhnw","stickyWrapper":"EditLanguage_stickyWrapper__+Lmc4"};